import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client/core';
import { provideApolloClient } from '@vue/apollo-composable';

// Reuse a single ApolloClient on the server to avoid creating a new client
// (with InMemoryCache, httpLink, etc.) per SSR request.
// Safe because fetchPolicy is 'no-cache' and resultCaching is false.
let serverClient: ApolloClient<unknown> | null = null;

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();

  if (import.meta.server && serverClient) {
    provideApolloClient(serverClient);
    return;
  }

  const httpLink = createHttpLink({
    uri: import.meta.client
      ? config.public.apollo.httpBrowserEndpoint
      : config.public.apollo.httpServerEndpoint,
  });

  const client = new ApolloClient({
    link: httpLink,
    cache: new InMemoryCache({
      resultCaching: false,
    }),
    ssrMode: true,
    devtools: {
      enabled: process.env.NODE_ENV === 'development',
    },
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    },
  });

  if (import.meta.server) {
    serverClient = client;
  }

  provideApolloClient(client);
});
